var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34.83 34.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 36.83,
    height: 36.88
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "cls-3",
    d: "M4.05,35.88h26a3,3,0,0,0,3.05-3.05V18.51a1,1,0,0,0-.3-.72,1,1,0,0,0-.71-.3,1,1,0,0,0-1,1V32.83a.94.94,0,0,1-1,1h-26a.94.94,0,0,1-1-1v-26a1,1,0,0,1,1-1h14.3a1,1,0,0,0,0-2H4.05A3,3,0,0,0,1,6.82v26A3,3,0,0,0,4.05,35.88ZM34.27,2.55C32.18.46,29.67.48,27.55,2.6l-17,17a1.47,1.47,0,0,0-.35.56c-2.28,6.67-2.47,7.3-2.48,7.33-.24.8-.25,1.35,0,1.59s.8.25,1.65,0c0,0,.67-.17,7.29-2.48a1.76,1.76,0,0,0,.55-.35l17-17c2.15-2.15,2.18-4.59.07-6.7ZM30.4,10.18,16.23,24.35a2.15,2.15,0,0,1-.8.49c-.88.26-4.38,1.56-4.38,1.56a.55.55,0,0,1-.56-.08.5.5,0,0,1-.07-.55L12,21.35a2.48,2.48,0,0,1,.5-.78L26.62,6.4l3.78,3.78Zm2.37-2.36L31.7,8.88,27.92,5.1,29,4a2.74,2.74,0,0,1,2-.93A2.71,2.71,0,0,1,32.84,4a2.52,2.52,0,0,1-.07,3.83Z",
    transform: "translate(-1 -1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.bb77eb2546994468308fde98b9774cb3.svg";
export { ForwardRef as ReactComponent };